import { Alert, AlertTitle } from '@mui/material';
import { useState } from 'react';

interface ErrorProps {
  titulo?: string;
  mensaje: string;
  severity?: 'error' | 'info' | 'warning';
}

// USARLO SOLO PARA ERRORES DE FETCH
const ErrorBanner = ({ mensaje, titulo = 'Error', severity = 'error' }: ErrorProps) => {
  const [errorMsg, setErrorMsg] = useState(mensaje);

  if (errorMsg === '') {
    return null;
  }

  return (
    <Alert severity={severity} onClose={() => setErrorMsg('')} sx={{ zIndex: 999, position: 'relative', mt: 2 }}>
      <AlertTitle textAlign="left">{titulo}</AlertTitle>
      {mensaje}
    </Alert>
  );
};

export default ErrorBanner;
